/**
 * The Hidden component renders nothing.
 */
import { FC } from "react"

export const Hidden: FC = () => {
    return null
}
